<template>
	<div
		id="part_service"
		v-if="[1, 2].includes(car.basic.business_type) && imageUrl"
		v-sd-exp:VehicleDetailExpo="{
			page: '二手车车辆详情页',
			label_name: car.$$track_label_name,
			tag: car.$$track_tags,
			module_name: car.basic.business_type === 1 ? '车主权益' : '交易公约',
			position_rank: car.basic.business_type === 1 ? 5 : 4,
			position_in_number: 1,
			position_in_rank: 1,
			track_sign: 'aMall.b4307.exposure.VehicleDetailExpo'
		}"
		v-sd-clk:VehicleDetailClick="{
			page: '二手车车辆详情页',
			label_name: car.$$track_label_name,
			tag: car.$$track_tags,
			module_name: car.basic.business_type === 1 ? '车主权益' : '交易公约',
			button_name: car.basic.business_type === 1 ? '车主权益' : '交易公约',
			position_rank: car.basic.business_type === 1 ? 5 : 4,
			position_in_rank: 1,
			position_in_number: 1,
			track_sign: 'aMall.b4307.click.VehicleDetailClick'
		}"
	>
		<template v-if="car.basic.business_type === 1">
			<div class="section-title">车主权益</div>
			<img style="width: 100%;height: 100%" :src="cdn(imageUrl, '/thumbnail/!670x466r', true)" />
		</template>
		<template v-else>
			<img style="width: 100%;height: 100%" :src="cdn(imageUrl, '/thumbnail/!670x954r', true)" />
		</template>
	</div>
</template>

<script>
import { commonConfigModel } from '@/model'
import { cdn } from '@/util/imgCdn'

export default {
	name: 'CarRight',
	props: ['car'],

	data() {
		return {
			ImgHolderRight: '',
			ImgBaasRight: '',
			ImgC2C: ''
		}
	},
	created() {
		this.getRightsImgsConfig()
	},
	computed: {
		imageUrl() {
			if (this.car.basic.business_type === 1) {
				return this.car.basic.is_baas ? this.ImgBaasRight : this.ImgHolderRight
			}
			return this.ImgC2C
		}
	},

	methods: {
		cdn,
		async getRightsImgsConfig() {
			const res = await commonConfigModel.get({
				keys: 'right',
				brand: this.car.basic.brand
			})

			const { baas_right, c2c_right, holder_right } = res.data.data.right

			this.ImgHolderRight = holder_right
			this.ImgC2C = c2c_right
			this.ImgBaasRight = baas_right
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

#part_service {
	margin-top: 60px;
	.section-title {
		@include subtitle_1(1.4, 400, false);
		color: $text_primary;
		margin-bottom: 20px;
	}
}
</style>
